import { render } from "./CitizenshipDocumentationView.vue?vue&type=template&id=e6da2a4a"
import script from "./CitizenshipDocumentationView.vue?vue&type=script&lang=js"
export * from "./CitizenshipDocumentationView.vue?vue&type=script&lang=js"

import "./CitizenshipDocumentationView.vue?vue&type=style&index=0&id=e6da2a4a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__